import { state, setState } from './state'

export function advanceStory(nextStep, storyState) {
  const story = Object.assign({}, state.story, { currentStep: nextStep })
  setState({ story })
}